import { render, staticRenderFns } from "./UserTop.vue?vue&type=template&id=11f207cd&scoped=true"
import script from "./UserTop.vue?vue&type=script&lang=js"
export * from "./UserTop.vue?vue&type=script&lang=js"
import style0 from "./UserTop.vue?vue&type=style&index=0&id=11f207cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f207cd",
  null
  
)

export default component.exports